import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Grid, IconButton, Skeleton, Tooltip, Typography, useTheme } from '@mui/material';
import React from 'react';

interface Props {
  pageTitle: string;
  pageSubtitle?: React.ReactNode;
  onBackClick?: () => void;
  isCohort?: boolean;
  renderCohortDetailsToggle?: () => React.ReactNode;
  leadingAction?: React.ReactNode;
  trailingAction?: React.ReactNode;
}

export const pageHeaderHeight = 62;

const PageHeader = ({
  pageTitle,
  pageSubtitle,
  onBackClick,
  isCohort,
  renderCohortDetailsToggle,
  leadingAction,
  trailingAction,
}: Props) => {
  const theme = useTheme();
  return (
    <Grid item container alignItems="center" height={pageHeaderHeight} wrap="nowrap">
      {(leadingAction || onBackClick) && (
        <Grid item sx={{ flexShrink: 0 }}>
          {leadingAction ?? (
            <IconButton
              onClick={onBackClick}
              size="small"
              sx={{
                backgroundColor: theme.palette.secondary.main,
                mr: 2,
                borderRadius: '50%',

                color: theme.palette.primary.contrastText,
                '&:hover': {
                  backgroundColor: theme.palette.secondary.dark,
                },
              }}
            >
              <KeyboardBackspaceIcon />
            </IconButton>
          )}
        </Grid>
      )}
      <Grid item xs={true} container spacing={2} wrap="nowrap" sx={{ minWidth: 0 }}>
        <Grid item container direction="column" xs={true} sx={{ minWidth: 0 }}>
          <Tooltip title={pageTitle} arrow placement="top">
            {pageTitle ? (
              <Typography
                variant="h1"
                sx={{
                  minWidth: 0,
                  fontWeight: theme.typography.fontWeightBold,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
                color="text.primary"
              >
                {pageTitle}
              </Typography>
            ) : (
              <Skeleton variant="rectangular" width={400} height={40} />
            )}
          </Tooltip>
          {pageSubtitle}
        </Grid>
        {isCohort && (
          <Grid
            item
            xs={1}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <CollectionsBookmarkIcon fontSize="large" />
          </Grid>
        )}

        {renderCohortDetailsToggle && renderCohortDetailsToggle()}
      </Grid>
      {trailingAction && (
        <Grid item sx={{ flexShrink: 0, ml: 2 }}>
          {trailingAction}
        </Grid>
      )}
    </Grid>
  );
};

export default PageHeader;
